const insertContent = (editor, insertData) => editor?.chain().focus().insertContent([insertData]).run();

export default insertContent;
